import { Component } from '@angular/core';

@Component({
  selector: 'app-test-selector',
  templateUrl: './test-selector.component.html',
  styleUrls: ['./test-selector.component.scss']
})
export class TestSelectorComponent {

  constructor() { }

  changeLanguage(languageCode: string): void {
    console.log('Idioma cambiado a:', languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
    document.documentElement.lang = languageCode;
    
    // Actualizar UI del selector
    const btnEs = document.getElementById('btn-es');
    const btnEn = document.getElementById('btn-en');
    
    if (btnEs && btnEn) {
      btnEs.classList.remove('active');
      btnEn.classList.remove('active');
      
      if (languageCode === 'es') {
        btnEs.classList.add('active');
      } else {
        btnEn.classList.add('active');
      }
    }
  }

  ngOnInit(): void {
    // Inicializar estado del selector
    const savedLang = localStorage.getItem('selectedLanguage') || 'es';
    this.changeLanguage(savedLang);
  }
}
